import type Store from "@ember-data/store";
import type MedicModel from "parog-web/models/medic";
import type FetcherService from "parog-web/services/fetcher";
import type SemeiaFeaturesService from "parog-web/services/semeia-features";
import type { CnamManagerAdapter } from "./cnam-manager-adapter";
import DmpConnectJSCnamManagerAdapter from "./dmpconnect-js/cnam-manager-adapter";

export enum DmpAdapterName {
  DMPConnectJsLocal = "dmpconnect_js",
  DMPConnectJsOlaqin = "dmpconnect_js_olaqin"
}
export default class CnamManagerFactory {
  static getCnamManagerAdapter(
    medic: MedicModel,
    store: Store,
    fetcher: FetcherService,
    accessToken: string,
    semeiaFeaturesService: SemeiaFeaturesService,
    requestManager
  ): CnamManagerAdapter {
    switch (medic.dmpAdapterName) {
      case DmpAdapterName.DMPConnectJsLocal:
      case DmpAdapterName.DMPConnectJsOlaqin:
      default:
        return new DmpConnectJSCnamManagerAdapter(
          medic,
          store,
          accessToken,
          fetcher,
          requestManager,
          semeiaFeaturesService
        );
    }
  }
}
